//mypreset.ts
import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

const D4MaterialPreset = definePreset(Material, {
  semantic: {
    primary: {
      50: '#ebf1ff',
      100: '#d5e3ff',
      200: '#a9c1da',
      300: '#7c94ad',
      400: '#4e6781',
      500: '#193356',
      600: '#2a405f',
      700: '#193356',
      800: '#162e4f',
      900: '#122745',
      950: '#0e203c'
    }
  }
});

export default D4MaterialPreset;

